import styled from '@emotion/styled';
import React, {useContext, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ETextInput} from 'webapp-lib/Components';
import {mixinFlexboxRow} from 'webapp-lib/styling';
import {onEnterPress} from 'webapp-lib/utils';

import {TimeEntryResponse} from '@lexian/api/timetracker-api';

import {TimerFacade} from '../../timetracker.types';
import {PlayButton} from '../PlayButton';
import {CalendarAPIContext} from '../TimetrackerButton';

import {ElapsedTime} from './ElapsedTime';

export function Timer({
  ongoingTimeEntry,
  timer,
}: {
  ongoingTimeEntry: TimeEntryResponse | undefined;
  timer: TimerFacade;
}): React.ReactElement {
  const {t} = useTranslation('timetracker');

  const [timerEntry, setTimerEntry] = useState<string>('');
  const calendarContext = useContext(CalendarAPIContext);

  const isEmpty = timerEntry.trim() === '';
  const isOngoing = ongoingTimeEntry !== undefined;

  const handlePlayPressed = () => {
    timer.start({title: timerEntry});
  };
  const handlePausePressed = () => {
    setTimerEntry('');
    timer.stop();
  };

  return (
    <TimerBox>
      <ETextInput
        autoFocus={true}
        disabled={isOngoing}
        endAdornment={
          <ButtonRow>
            {isOngoing && (
              <ElapsedTime
                key={ongoingTimeEntry.id}
                ongoingEntry={ongoingTimeEntry}
              />
            )}
            <PlayButton
              disabled={isEmpty && !isOngoing}
              isOngoing={isOngoing}
              startTimer={handlePlayPressed}
              stopTimer={handlePausePressed}
            />
          </ButtonRow>
        }
        inputRef={calendarContext.timerInputRef}
        largeEndAdornment={true}
        placeholder={t('components.timer.placeholder')}
        size='large'
        value={isOngoing ? ongoingTimeEntry.title : timerEntry}
        onChange={(evt) => setTimerEntry(evt.target.value)}
        onKeydown={onEnterPress(() => handlePlayPressed())}
      />
    </TimerBox>
  );
}

const TimerBox = styled.div`
  padding: var(--gutter-medium);
  padding-bottom: 0;

  .MuiInputBase-root {
    .Mui-disabled {
      color: var(--text-primary-color);
      -webkit-text-fill-color: black;
    }
  }
`;

const ButtonRow = styled.div`
  ${mixinFlexboxRow};
  align-items: center;
`;
